import { defineStore } from 'pinia'
import type { BuildingMaster, BuildingStructureItem } from '@/types/Facet'

export const useMasterStore = defineStore('master', {
  state: () => ({
    mansion: null as BuildingMaster | null,   // buildingType=1
    house: null as BuildingMaster | null   // buildingType=2
  }),
  actions: {
    setMansion(data: BuildingMaster) {
      this.mansion = data
    },
    setHouse(data: BuildingMaster) {
      this.house = data
    }
  }
})